import React, { useEffect, useState, useRef } from "react";
import SocialHead from "@/components/SEO/SocialHead";
import MoviesCategories from "@/components/navigation/MoviesCategories";
import qs from "qs";
import apiClient from "@/utils/apiClient";
import { TourBannerHero } from "@/components/banners/TourBanner";
import MoviesCatalog from "@/components/movies/MoviesCatalog";
import PublicationsCatalog from "@/components/publications/PublicationsCatalog";
import { Tab } from "@headlessui/react";
import { Nav } from "@/components/navigation/Navbar";
import * as Text from "@/components/text";
import Flicking from "@egjs/react-flicking";
import "@egjs/react-flicking/dist/flicking.css";
import ScrollingCalendar from "@/components/navigation/ScrollingCalendar";
import OnsiteEvents from "@/components/event/OnsiteEvents";
import OnlineEvents, {
  OnlineEventsCalendar,
} from "@/components/event/OnlineEvents";
import TvTour from "@/components/event/TvTour";
import animateScrollTo from "animated-scroll-to";
import useWindowSize from "@/hooks/useWindowSize";
import { InView } from "react-intersection-observer";
import GiraDocumental from "./giraDocumentales";
import { localeTexts } from "@/utils/locale";

import {
  motion,
  useScroll,
} from "framer-motion";
import classNames from "classnames";
import AnchorChip from "@/components/lib/AnchorChip";

export default function Gira({
  seccion,
  sections,
  entries,
  fest,
  moviesBySection,
  entriesByCategory,
  categories,
  dataGira,
  isActiveGira,
  locale,
}) {
  const [smallDiv, setSmallDiv] = useState(false);
  const [section, setSection] = useState(seccion || "tour");
  const [category, setCategory] = useState("");
  const [moviesCategory, setMoviesCategory] = useState("");
  const [publicationCategory, setPublicationCategory] = useState("");
  const [giraData, setGiraData] = useState({ ...dataGira });
  const [festData, setFestData] = useState(fest);
  const [localizedSections, setLocalizedSections] = useState(sections);

  useEffect(() => {
    if (fest && locale !== "es-MX" && fest.localizations?.data?.length > 0) {
      const localizedData = fest.localizations.data.find(
        (l) => l.attributes.locale === locale
      );
      if (localizedData) {
        setFestData({ ...fest, ...localizedData.attributes });
      } else {
        setFestData(fest);
      }
    } else if (fest) {
      setFestData(fest);
    }
  }, [locale, fest]);

  useEffect(() => {
    if (sections && locale !== "es-MX") {
      const newSections = sections.map((section) => {
        if (section.localizations?.data?.length > 0) {
          const localizedData = section.localizations.data.find(
            (localization) => localization.attributes.locale === locale
          );
          if (localizedData) {
            return { ...section, ...localizedData.attributes };
          }
        }
        return section;
      });
      setLocalizedSections(newSections);
    } else if (sections) {
      setLocalizedSections(sections);
    }
  }, [locale, sections]);

  // Add this useEffect in your Gira component
  useEffect(() => {
    if (locale !== "es-MX" && dataGira?.localizations?.data?.length > 0) {
      // Find the English localization
      const englishData = dataGira.localizations.data.find(
        (localization) => localization.attributes.locale === locale
      );

      if (englishData) {
        setGiraData({
          ...dataGira, // Preserve other attributes
          ...englishData.attributes, // Override with English attributes
        });
      }
    } else {
      // Reset to the default locale (original attributes)
      setGiraData({ ...dataGira });
    }
  }, [locale, dataGira]);

  const [activeTab, setActiveTab] = useState(0);
  const [showCoordenadasList, setShowCoordenadasList] = useState(false);

  const [selectedCoordenada, setSelectedCoordenada] = useState(() => {
    const coordenadas = localizedSections
      ?.filter((section) => section.name.toLowerCase().includes("coor"))
      ?.sort((a, b) => a.name.localeCompare(b.name)); // Alphabetical sort

    return coordenadas?.[0]?.name || null;
  });

  useEffect(() => {
    if (localizedSections?.length > 0 && !selectedCoordenada) {
      const firstCoordenada = localizedSections.find((section) =>
        section.name.toLowerCase().includes("coor")
      )?.name;
      setSelectedCoordenada(firstCoordenada);
    }
  }, [localizedSections]);
  useEffect(() => {
    if (section) {
      const s = {
        movies: "programacion",
        tour: "calendario",
        posts: "publicaciones",
        tvTour: "gira-television",
        onlineTour: "gira-digital",
      }[section];

      // add section to query params

      const url = new URL(window.location.href);
      url.searchParams.set("seccion", s);
      window.history.replaceState({}, "", url);
    }
  }, [section]);

  useEffect(() => {
    let selectedIndex = {
      movies: 0,
      tour: isActiveGira.tv_tour ? 1 : 3,
      posts: 2,
      tvTour: 3,
      onlineTour:
        isActiveGira.tv_tour && isActiveGira.on_site_tour
          ? 4
          : (!isActiveGira.tv_tour && isActiveGira.on_site_tour) ||
            (isActiveGira.tv_tour && !isActiveGira.on_site_tour)
            ? 1
            : 3,
    }[section || "tour"];
    setActiveTab(selectedIndex);
  }, [section]);

  const headerRef = useRef(null);
  const navRef = useRef(null);
  const contentRef = useRef(null);
  const heroRef = useRef(null);

  // publications refs
  const programacionRef = useRef(null);
  const noticiasRef = useRef(null);
  const textosRef = useRef(null);
  const windowSize = useWindowSize();

  // useEffect(() => {
  //   if (window && category) {
  //     const element = document.getElementById(category);
  //     // Add null check to prevent error
  //     if (element) {
  //       element.scrollIntoView({
  //         behavior: "smooth",
  //         block: "center",
  //       });
  //     }
  //   }
  // }, [category, smallDiv]);

  useEffect(() => {
    if (publicationCategory) {
      const r = document.getElementById(publicationCategory);
      animateScrollTo(r, {
        verticalOffset: smallDiv ? -300 : -550,
      });
    }
  }, [publicationCategory]);

  useEffect(() => {
    if (moviesCategory) {
      const r = document.getElementById(moviesCategory);
      animateScrollTo(r, {
        verticalOffset: smallDiv ? -300 : -550,
      });
    }
  }, [moviesCategory, windowSize.width]);

  useEffect(() => {
    if (isActiveGira && contentRef?.current) {
      if (smallDiv) {
        // document.body.style.paddingTop = "50px";
        contentRef.current.style.marginTop = 50 + "px";
      } else {
        // document.body.style.paddingTop = "0px";
        contentRef.current.style.marginTop = 0 + "px";
      }
    }
  }, [smallDiv]);

  const { scrollY } = useScroll({
    ref: contentRef,
  });

  const scrollRef = useRef(null);

  const scroll = (scrollOffset) => {
    if (scrollRef.current) {
      scrollRef.current.scrollLeft += scrollOffset;
    }
  };

  // useEffect(() => {
  //   scrollY.onChange((latest) => {
  //     if (latest > 65) {
  //       document.body.style.paddingTop = "100px";

  //       setSmallDiv(true);
  //     } else if (latest <= 65) {
  //       document.body.style.paddingTop = "0px";
  //       setSmallDiv(false);
  //     }
  //   });

  //   return () => {
  //     scrollY.destroy();
  //     document.body.style.paddingTop = "0px";
  //   };
  // }, []);

  // Add this useEffect to set initial category
  useEffect(() => {
    if (sections?.length > 0 && !category) {
      setCategory(sections[0].name);
    }
  }, [sections, category]);

  return (
    <div>
      <SocialHead title="Gira - Ambulante" description="Gira de documentales" />

      <InView
        initialInView={true}
      // onChange={(inView, entry) => setSmallDiv(!inView)}
      >
        <motion.div className="amb-container" ref={navRef}>
          <Nav theme="light" />
        </motion.div>
      </InView>

      {isActiveGira.active_tour ? (
        <Tab.Group as="div" selectedIndex={activeTab}>
          <div
            ref={headerRef}
            style={{
              width: "100%",
              top: 0,
              position: "relative",
            }}
            className="z-10"
          >
            <div ref={heroRef}>
              <TourBannerHero
                image={festData?.hero_image?.data?.attributes?.url}
                fromDate={festData?.start_date}
                toDate={festData?.end_date}
                title={festData?.name}
                description={festData?.description}
                videoUrl={festData?.promotional_video}
                simple={!smallDiv}
              />
            </div>
            <div className="">
              <Tab.List
                as="nav"
                className={classNames(
                  smallDiv ? " " : "border-b border-neutral-500",
                  "w-full bg-white "
                )}
              >
                <div className="amb-container flex gap-5 ">
                  <Flicking moveType="freeScroll" className="m-0" bound={true}>
                    <Tab
                      as="div"
                      onClick={() => setSection("movies")}
                      className={({ selected }) =>
                        classNames(
                          selected
                            ? "border-b-4 border-neutral-900"
                            : "border-b-4 border-transparent",
                          "group  box-border  cursor-pointer p-5 hover:border-b-neutral-900"
                        )
                      }
                    >
                      <Text.Label
                        size="lg"
                        className="flex gap-x-3 text-neutral-500 group-hover:text-neutral-1000"
                      >
                        {/* {localeTexts[locale].gira.programacion} */}Programación
                      </Text.Label>
                    </Tab>

                    <Tab
                      as="div"
                      onClick={() => setSection("tour")}
                      className={({ selected }) =>
                        classNames(
                          selected
                            ? "border-b-4 border-neutral-900"
                            : "border-b-4 border-transparent",
                          "group  box-border  cursor-pointer p-5 hover:border-b-neutral-900 "
                        )
                      }
                    >
                      <Text.Label
                        size="lg"
                        className="flex gap-x-3 text-neutral-500 group-hover:text-neutral-1000"
                      >
                        Calendario
                      </Text.Label>
                    </Tab>

                    {isActiveGira.tv_tour && (
                      <Tab
                        as="div"
                        onClick={() => setSection("posts")}
                        className={({ selected }) =>
                          classNames(
                            selected
                              ? "border-b-4 border-neutral-900"
                              : "border-b-4 border-transparent",
                            "group  box-border  cursor-pointer p-5 hover:border-b-neutral-900"
                          )
                        }
                      >
                        <Text.Label
                          size="lg"
                          className="flex gap-x-3 text-neutral-500 group-hover:text-neutral-1000"
                        >
                          Publicaciones
                        </Text.Label>
                      </Tab>
                    )}

                    {isActiveGira.on_site_tour && (
                      <Tab
                        as="div"
                        onClick={() => setSection("tvTour")}
                        className={({ selected }) =>
                          classNames(
                            selected
                              ? "border-b-4 border-neutral-900"
                              : "border-b-4 border-transparent",
                            "group  box-border  cursor-pointer p-5 hover:border-b-neutral-900"
                          )
                        }
                      >
                        <Text.Label
                          size="lg"
                          className="flex gap-x-3 text-neutral-500 group-hover:text-neutral-1000"
                        >
                          En televisión
                        </Text.Label>
                      </Tab>
                    )}

                    {isActiveGira.online_tour && (
                      <Tab
                        as="div"
                        onClick={() => setSection("onlineTour")}
                        className={({ selected }) =>
                          classNames(
                            selected
                              ? "border-b-4 border-neutral-900"
                              : "border-b-4 border-transparent",
                            "group  box-border  cursor-pointer p-5 hover:border-b-neutral-900"
                          )
                        }
                      >
                        <Text.Label
                          size="lg"
                          className="flex gap-x-3 text-neutral-500 group-hover:text-neutral-1000"
                        >
                          Gira en línea
                        </Text.Label>
                      </Tab>
                    )}
                  </Flicking>
                </div>
              </Tab.List>
              {/* &nbsp; */}
              {smallDiv ? null : (
                <motion.div
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1, transition: { delay: 0.2 } }}
                  exit={{ opacity: 0 }}
                  className="amb-container"
                >
                  {section === "apoyo" ? (
                    <div className="md:flex md:items-center">
                      <Text.Display className="grow" as="h2">
                        Apoyo
                      </Text.Display>
                      <Text.Body
                        className="max-w-screen-md text-neutral-400 md:text-right"
                        fontWeight="light"
                        size="xl"
                      >
                        Desde 2005 hemos trabajado para construir una sociedad
                        más crítica, empática, abierta y comprometida gracias al
                        apoyo de nuestros aliados.
                      </Text.Body>
                    </div>
                  ) : null}
                </motion.div>
              )}
              <div
                className={classNames(
                  smallDiv ? "mt-0 bg-neutral-50 py-4 " : "bg-white pt-16 ",
                  "  "
                )}
              >
                <div className="amb-container">
                  {section === "posts" ? (
                    <div className="space-y-6 ">
                      {smallDiv ? null : (
                        <Text.Display as="h2">Publicaciones</Text.Display>
                      )}
                      <MoviesCategories
                        categories={categories
                          ?.filter(
                            (category) =>
                              entriesByCategory[category.attributes.name]
                                ?.length > 0
                          )
                          ?.map((entry) => entry.attributes.name)}
                        selected={publicationCategory}
                        setSelected={setPublicationCategory}
                      />
                    </div>
                  ) : null}
                  {section === "movies" ? (
                    <div className="space-y-6 ">
                      <div className="space-y-3">
                        {smallDiv ? null : (
                          <motion.div
                            initial={{ opacity: 0, display: "block" }}
                            animate={{
                              opacity: 1,
                              transition: { delay: 0.2 },
                            }}
                            exit={{
                              opacity: 0,
                              display: "none",
                              transition: { delay: 0.2 },
                            }}
                          >
                            <Text.Display as="h2">Secciones</Text.Display>
                          </motion.div>
                        )}
                      </div>
                      {sections?.length > 0 && (
                        <div className="relative">
                          <div className="my-5 flex items-center gap-4">
                            {/* Left Arrow */}
                            <button
                              onClick={() => scroll(-200)}
                              className="hidden rounded-full bg-white p-2 shadow-md transition-shadow hover:shadow-lg md:block"
                              aria-label="Scroll left"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className="h-6 w-6 text-gray-600"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth={2}
                                  d="M15 19l-7-7 7-7"
                                />
                              </svg>
                            </button>

                            {/* Scrollable Container */}
                            <div
                              ref={scrollRef}
                              className="scrollbar-hide flex flex-1 gap-2 overflow-x-auto pb-4"
                            >
                              {[
                                ...sections
                                  .filter(
                                    (section) =>
                                      !section.name
                                        .toLowerCase()
                                        .includes("coor")
                                  )
                                  .map((section) => ({
                                    ...section,
                                    isSpecial: false,
                                  })),

                                // Add virtual Coordenadas section
                                {
                                  id: "virtual-coordenadas",
                                  name: "Coordenadas",
                                  short_title: "Coordenadas",
                                  isSpecial: true,
                                },
                              ]
                                .sort((a, b) => a.name.localeCompare(b.name))
                                .map((section) => (
                                  <AnchorChip
                                    key={section.id}
                                    active={
                                      category ===
                                      (section.isSpecial
                                        ? "Coordenadas"
                                        : section.name)
                                    }
                                    onClick={() =>
                                      setCategory(
                                        section.isSpecial
                                          ? "Coordenadas"
                                          : section.name
                                      )
                                    }
                                  >
                                    {section.short_title}
                                  </AnchorChip>
                                ))}
                            </div>

                            <button
                              onClick={() => scroll(200)}
                              className="hidden rounded-full bg-white p-2 shadow-md transition-shadow hover:shadow-lg md:block"
                              aria-label="Scroll right"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className="h-6 w-6 text-gray-600"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth={2}
                                  d="M9 5l7 7-7 7"
                                />
                              </svg>
                            </button>
                          </div>
                        </div>
                      )}
                    </div>
                  ) : null}

                  {section === "tvTour" ? (
                    <div className="space-y-2">
                      {smallDiv ? null : (
                        <Text.Display as="h2">Gira en televisión</Text.Display>
                      )}
                      <TvTour />
                    </div>
                  ) : null}

                  {section === "tour" ? (
                    <div className="space-y-6 ">
                      {smallDiv ? null : (
                        <Text.Display as="h2">Calendario</Text.Display>
                      )}
                      <ScrollingCalendar />
                    </div>
                  ) : null}

                  {section === "onlineTour" ? (
                    <div className="space-y-6 ">
                      {smallDiv ? null : (
                        <Text.Display as="h2">Gira en línea</Text.Display>
                      )}
                      <OnlineEventsCalendar />
                    </div>
                  ) : null}
                </div>
              </div>
            </div>
          </div>

          <Tab.Panels ref={contentRef}>
            <Tab.Panel>
              <div className="amb-container">
                {category === "Coordenadas" ? (
                  <>
                    {sections
                      ?.filter(
                        (section) =>
                          section.name.toLowerCase().includes("coor") &&
                          section.name === selectedCoordenada
                      )
                      ?.sort((a, b) => a.name.localeCompare(b.name))
                      .map((section) => (
                        <div
                          key={section.slug}
                          className="mx-auto max-w-5xl px-4 lg:px-0"
                        >
                          <div className="mx-6 mb-8 space-y-4">
                            <div className="flex items-center justify-between gap-4">
                              <div className="flex items-center gap-4">
                                <h2 className="text-2xl font-bold text-neutral-900 md:text-3xl">
                                  {section.name}
                                </h2>
                                <div className="relative">
                                  <button
                                    onClick={() =>
                                      setShowCoordenadasList(
                                        !showCoordenadasList
                                      )
                                    }
                                    className="rounded-full bg-neutral-900 px-4 py-2 text-sm text-white transition-colors hover:bg-neutral-700 md:text-base"
                                  >
                                    Otros Estados
                                  </button>
                                  {showCoordenadasList && (
                                    <div className="absolute right-0 top-full z-50 mt-2 w-64 rounded-lg bg-white p-4 shadow-lg">
                                      <div className="max-h-60 space-y-2 overflow-y-auto">
                                        {sections
                                          ?.filter((s) =>
                                            s.name
                                              .toLowerCase()
                                              .includes("coor")
                                          )
                                          ?.sort((a, b) =>
                                            a.name.localeCompare(b.name)
                                          )
                                          .map((s) => (
                                            <button
                                              key={s.slug}
                                              onClick={() => {
                                                setSelectedCoordenada(s.name);
                                                setShowCoordenadasList(false);
                                              }}
                                              className="w-full rounded-md p-2 text-left transition-colors hover:bg-neutral-50"
                                            >
                                              {s.name}
                                            </button>
                                          ))}
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>

                            {section?.description && (
                              <p className="leading-6 sm:text-center sm:text-base md:text-lg lg:text-justify">
                                {section.description}
                              </p>
                            )}
                          </div>

                          <MoviesCatalog
                            id={section.slug}
                            movies={moviesBySection[section.slug]}
                            className="mt-6"
                          />
                        </div>
                      ))}
                  </>
                ) : (
                  sections
                    ?.filter((section) => section.name === category)
                    .map((section) => (
                      <MoviesCatalog
                        key={section.slug}
                        id={section.name}
                        movies={moviesBySection[section.slug]}
                        title={section.name}
                        description={section?.description || ""}
                        className="px-4 lg:px-0"
                      />
                    ))
                )}
              </div>
            </Tab.Panel>

            <Tab.Panel>
              <div className="amb-container">
                {section === "tour" ? <OnsiteEvents /> : null}
              </div>
            </Tab.Panel>

            {isActiveGira.tv_tour && (
              <Tab.Panel>
                <div className="amb-container space-y-10">
                  {categories?.length > 0 &&
                    Object.keys(entriesByCategory).map((entry, i) => (
                      <PublicationsCatalog
                        id={entry}
                        key={i}
                        title={entry}
                        publications={entriesByCategory[entry]}
                      />
                    ))}
                </div>
              </Tab.Panel>
            )}
            <div className="amb-container">
              {section === "onlineTour" ? <OnlineEvents /> : null}
            </div>
          </Tab.Panels>
        </Tab.Group>
      ) : (
        <GiraDocumental giraData={giraData} locale={locale} />
      )}
    </div>
  );
}

export async function getServerSideProps(context) {
  const { locale, seccion: seccionQuery } = context.query;
  console.log('[DEBUG] Environment check:', {
    STRAPI_URL: process.env.NEXT_PUBLIC_STRAPI_URL,
    HAS_TOKEN: !!process.env.NEXT_PUBLIC_STRAPI_TOKEN,
    IS_ACTIVE_TOUR: process.env.NEXT_PUBLIC_IS_ACTIVE_TOUR
  });
  try {
    console.log('[getServerSideProps] Start', { locale, seccionQuery });
    const activeGira = await apiClient.get(`/api/configuracion-global`);
    console.log('[getServerSideProps] activeGira', activeGira?.data?.data?.attributes);
    const isActiveGira = {
      on_site_tour:
        process.env.NEXT_PUBLIC_IS_ACTIVE_TOUR === "false" ||
        activeGira.data.data.attributes.on_site_tour,
      online_tour:
        process.env.NEXT_PUBLIC_IS_ACTIVE_TOUR === "false" ||
        activeGira.data.data.attributes.online_tour,
      tv_tour:
        process.env.NEXT_PUBLIC_IS_ACTIVE_TOUR === "false" ||
        activeGira.data.data.attributes.tv_tour,
      active_tour:
        process.env.NEXT_PUBLIC_IS_ACTIVE_TOUR === "false" ||
        activeGira.data.data.attributes.active_tour,
    };
    console.log('[getServerSideProps] isActiveGira', isActiveGira);
    const populateTourYear = qs.stringify({
      populate: {
        localizations: "*",
        ediciones_gira: {
          populate: "*",
        },
      },
    });
    const tourYear = await apiClient.get(`/api/tour?${populateTourYear}`);
    console.log('[getServerSideProps] tourYear', tourYear?.data?.data?.attributes);

    const seccion = {
      calendario: isActiveGira.on_site_tour ? "tour" : null,
      "gira-digital": isActiveGira.online_tour ? "onlineTour" : null,
      "gira-television": isActiveGira.tv_tour ? "tvTour" : null,
      programacion: "movies",
      publicaciones: "posts",
    }[seccionQuery || "programacion"];
    console.log('[getServerSideProps] resolved seccion', seccion);

    if (isActiveGira.active_tour) {
      const populateFest = qs.stringify({
        populate: {
          localizations: "*",
          entradas: {
            populate: "*",
            publicationState: "live",
          },
          hero_image: {
            populate: "*",
          },
        },
        filters: {
          name: {
            $eq: tourYear.data.data.attributes.ediciones_gira.data[0].attributes
              .name,
          },
        },
      });
      const fest = await apiClient.get(`api/ediciones-gira?${populateFest}`);
      console.log('[getServerSideProps] fest', fest?.data?.data?.[0]?.attributes);

      const movies = await apiClient.get(
        `api/films?${qs.stringify({
          populate: {
            localizations: "*",
            Directores: "*",
            film_year: "*",
            countries: "*",
            film_cover_image: "*",
            secciones: "*",
          },
          filters: {
            ediciones_giras: {
              name: {
                $eq: tourYear.data.data.attributes.ediciones_gira.data[0]
                  .attributes.name,
              },
            },
          },
          pagination: {
            pageSize: 150,
          },
        })}`
      );
      console.log('[getServerSideProps] movies count', movies?.data?.data?.length);

      let moviesBySection = {};
      let sectionsIdArray = [];

      if (movies.data.data.length > 0) {
        moviesBySection = movies.data.data.reduce((acc, movie) => {
          const section = movie?.attributes.secciones.data[0]?.attributes.slug;
          if (acc[section]) {
            acc[section].push(movie);
          } else {
            acc[section] = [movie];
          }
          return acc;
        }, {});

        sectionsIdArray = Object.keys(moviesBySection).map((section) => {
          return moviesBySection[section][0]?.attributes.secciones.data[0]?.id;
        });
      }
      console.log('[getServerSideProps] moviesBySection keys', Object.keys(moviesBySection));
      console.log('[getServerSideProps] sectionsIdArray', sectionsIdArray);

      const q = qs.stringify({
        filters: {
          id: {
            $in: sectionsIdArray,
          },
        },
        populate: {
          localizations: "*",
        },
      });
      const sectionsRequest = await apiClient.get(`api/sections?${q}`);
      console.log('[getServerSideProps] sectionsRequest count', sectionsRequest?.data?.data?.length);
      const sections = sectionsRequest.data.data.map((section) => {
        return section.attributes;
      });

      const entriesByCategory =
        fest.data.data[0].attributes.entradas.data.reduce((acc, entry) => {
          if (!entry.attributes?.categorias?.data[0]?.attributes?.slug) {
            // assign to "otros" category
            if (acc["Otros"]) {
              acc["Otros"].push(entry);
            } else {
              acc["Otros"] = [entry];
            }
            return acc;
          }
          const category = entry.attributes.categorias.data[0].attributes.name;
          if (acc[category]) {
            acc[category].push(entry);
          } else {
            acc[category] = [entry];
          }
          return acc;
        }, {});
      console.log('[getServerSideProps] entriesByCategory keys', Object.keys(entriesByCategory));

      const categoriesIdArray = Object.keys(entriesByCategory).map(
        (category) => {
          if (category === "Otros") {
            return null;
          }
          return entriesByCategory[category][0].attributes.categorias.data[0]
            .id;
        }
      );
      console.log('[getServerSideProps] categoriesIdArray', categoriesIdArray);

      const entryCategoriesRequest = await apiClient.get(
        `api/categories?${qs.stringify({
          populate: {
            localizations: "*",
            entradas: {
              populate: "*",
            },
          },
          filters: {
            id: {
              $in: categoriesIdArray.filter((id) => id),
            },
          },
        })}`
      );
      console.log('[getServerSideProps] entryCategoriesRequest count', entryCategoriesRequest?.data?.data?.length);

      const categories = entryCategoriesRequest.data.data;

      categories.push({
        attributes: {
          name: "Otros",
          slug: "otros",
        },
      });
      console.log('[getServerSideProps] categories final count', categories.length);

      return {
        props: {
          seccion: seccion || "",
          sections,
          categories: entryCategoriesRequest.data.data,
          entriesByCategory,
          fest: fest.data.data[0].attributes,
          moviesBySection,
          isActiveGira: isActiveGira,
          locale: locale || "es-MX",
        },
      };
    } else {
      const deepPopulate = {
        headertitle: "*",
        peliculas: {
          populate: {
            film_cover_image: "*",
            Directores: "*",
            film_year: "*",
            countries: "*",
            iniciativas: "*",
          },
        },
        quotes: "*",
        edicion: {
          populate: {
            title: "*",
            subtitle: "*",
            description: "*",
            download_urls: "*",
            header: "*",
            preview_image: "*",
            media: {
              populate: {
                image: "*",
                title: "*",
                description: "*",
              },
            },
            media2: {
              populate: {
                image: "*",
                title: "*",
                description: "*",
              },
            },
          },
        },
      };

      const queryGira = qs.stringify({
        populate: {
          ...deepPopulate,
          localizations: {
            populate: deepPopulate,
          },
        },
      });
      const dataGira = await apiClient.get(`/api/gira-inactiva?${queryGira}`);
      console.log('[getServerSideProps] dataGira', dataGira?.data?.data?.attributes);
      return {
        props: {
          dataGira: dataGira.data.data.attributes,
          isActiveGira: isActiveGira,
          locale: locale || "es-MX",
        },
      };
    }
  } catch (err) {
    console.error('[getServerSideProps] ERROR', err);
    return {
      props: {
        notFound: true,
        error: err?.message || err,
      },
    };
  }
}
